export const formStyles = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
};

export const descriptionStyles = {
  marginBottom: '16px',
};
